import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { resolvePrismicLink } from "utils/prismicLinks";
import { ACCENT, HERO_BG, SECONDARYHERO_ORBS, heroGradientBoxProps } from "./heroBackground";

function CtaButton({ resolved, text, isPrimary, onNavigate }) {
  if (!resolved) return null;
  const styleProps = isPrimary
    ? { bg: ACCENT, color: HERO_BG, _hover: { bg: ACCENT, opacity: 0.9 } }
    : { variant: "outline", borderColor: "whiteAlpha.400", color: "white", _hover: { bg: "whiteAlpha.100" } };

  if (resolved.kind === "internal") {
    return (
      <Button {...styleProps} fontWeight="600" onClick={() => onNavigate(resolved.uid)}>
        {text}
      </Button>
    );
  }
  return (
    <Button as="a" href={resolved.url} target="_blank" rel="noopener noreferrer" {...styleProps} fontWeight="600">
      {text}
    </Button>
  );
}

export default function SecondaryheroSlice({ slice, onNavigate }) {
  const { heading, body_content, primary_cta, secondary_cta } = slice.primary;
  const primaryResolved = resolvePrismicLink(primary_cta);
  const secondaryResolved = resolvePrismicLink(secondary_cta);

  if (!heading && !body_content) return null;

  return (
    <Box {...heroGradientBoxProps} py={{ base: "80px", md: "112px" }} px={6} color="white" textAlign="center">
      {SECONDARYHERO_ORBS.map((orbProps, i) => (
        <Box key={i} {...orbProps} />
      ))}
      <VStack position="relative" zIndex={1} gap={4} maxW="600px" mx="auto">
        {heading && (
          <Text fontSize={{ base: "30px", md: "36px", lg: "48px" }} fontWeight="700" letterSpacing="tight" color="white">
            {heading}
          </Text>
        )}
        {body_content && (
          <Text fontSize={{ base: "18px", md: "20px" }} color="whiteAlpha.800">
            {body_content}
          </Text>
        )}
        <HStack gap={3}>
          <CtaButton resolved={primaryResolved} text={primary_cta?.text || "Contact"} isPrimary onNavigate={onNavigate} />
          <CtaButton
            resolved={secondaryResolved}
            text={secondary_cta?.text || "Learn more"}
            isPrimary={false}
            onNavigate={onNavigate}
          />
        </HStack>
      </VStack>
    </Box>
  );
}
